import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/open-mdx.png'
import _imports_1 from '@/assets/logo-nepen.png'


const _hoisted_1 = { class: "align-center bg- flex !h-screen !w-screen items-center justify-center bg-[linear-gradient(33deg,rgba(26,174,232,1)_0%,rgba(109,197,232,1)_50%,rgba(207,240,255,1)_100%)]" }
const _hoisted_2 = { class: "h-fit w-11/12 rounded-xl bg-[rgba(255,255,255,0.5)] p-8 shadow backdrop-blur-md sm:w-10/12 md:w-[420px] md:p-12" }
const _hoisted_3 = { class: "py-4 text-sky-900" }
const _hoisted_4 = { class: "mb-2 block font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_6 = { class: "mt-4 flex flex-col items-center justify-center gap-4" }

import SelectLanguage from '@/components/subcomponents/SelectLanguage.vue'
import * as loginServices from '@/services/userService'
import { useLanguageStore } from '@/stores/LanguageStore'
import { useAssociateValidator } from '@/validators/associateAccountValidator'
import { useToast } from 'primevue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Tag from 'primevue/tag'
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'AssociateAccount',
  setup(__props) {

const languageStore = useLanguageStore()
const toast = useToast()
const router = useRouter()

const { createForm, createEmptyErrors, validateForm } = useAssociateValidator()

const form = reactive(createForm())
const errors = reactive(createEmptyErrors())
const isLoading = ref(false)
const errorMessage = ref('')

const loginAd = () => {
  console.log(history.state)
  const validation = validateForm(form)
  if (!validation.isValid) {
    Object.assign(errors, validation.errors)
    return
  }

  isLoading.value = true
  errorMessage.value = ''

  loginServices
    .loginAd(history.state?.email, history.state?.password, form.email)
    .then((res) => {
      const access = loginServices.auth(router, res.data.accessToken, res.data.user)
      if (!access) {
        errorMessage.value = 'Usuário não tem acesso a esta aplicação'
      }
    })
    .catch((error) => {
      errorMessage.value = error?.response?.data?.detail
      if (errorMessage.value === 'UserNotAssociated') {
        router.push('/')
      }

      toast.add({
        summary: 'Erro',
        detail: errorMessage.value || 'Erro ao fazer login',
        severity: 'error',
        life: 3000,
      })
    })
    .finally(() => {
      isLoading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-4 flex items-center justify-center gap-4" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "logo openmdx",
          class: "h-18 w-auto"
        })
      ], -1)),
      _createVNode(_unref(Tag), {
        severity: "warn",
        value: _unref(languageStore).t('auth.login.associateWarn'),
        class: "mt-4 w-full"
      }, null, 8, ["value"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(languageStore).t('auth.login.emailLabel')), 1),
        _createVNode(_unref(InputText), {
          id: "email",
          type: "text",
          placeholder: _unref(languageStore).t('auth.login.placeholders.email'),
          onKeydown: _withKeys(loginAd, ["enter"]),
          modelValue: form.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
          class: _normalizeClass([{ 'p-invalid': errors.email }, "w-full"])
        }, null, 8, ["placeholder", "modelValue", "class"]),
        (errors.email)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(errors.email), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(Button), {
        label: _unref(languageStore).t('auth.login.associate'),
        class: "mb-2 w-full",
        onClick: loginAd,
        loading: isLoading.value
      }, null, 8, ["label", "loading"]),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_unref(Tag), {
            key: 0,
            severity: "danger",
            value: errorMessage.value,
            class: "mt-4 w-full"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_1,
          alt: "logo nepen",
          class: "h-8 w-auto"
        }, null, -1)),
        _createVNode(SelectLanguage, { opacity: 0.4 })
      ])
    ])
  ]))
}
}

})